var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phi-block-image"},[_c('img',{staticStyle:{"max-width":"100%","height":"auto"},attrs:{"src":_vm.block.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }